import { useMemo } from 'react';
import { Stack } from '../../shared/layouts';
import Card from '../../shared/Card';
import Table from '../../shared/Table';
import Header from '../../shared/Header';
import NextSvg from 'imagesUwKluis/svg/open.svg';
import { useNavigate } from 'react-router-dom';
import {useTranslation} from "react-i18next";
import useIconLibrary from "../../../hooks/useIconLibrary";

const columns = [
  {
    accessor: 'name',
    width: 300 * 0.33,
  },
  {
    accessor: 'data',
    width: 300 * 0.33,
  },
  {
    accessor: 'arrow',
    width: 300 * 0.1,
    align: 'right',
  },
];

const arrow = (
  <NextSvg
    width="1.5rem"
    height="1.5rem"
    css={(theme) => ({
      margin: 'calc((1rem - 1.5rem) / 2) 0',
      fill: theme?.colors?.secondaryFont || 'gray',
    })}
  />
);

const UserSection = ({ fullName, email, language }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { ProfileIcon } = useIconLibrary();

  const personData = useMemo(
    () => [
      {
        name: t('Naam'),
        data: fullName,
        url: '/user/settings/edit-name',
        arrow,
      },
    ],
    [fullName]
  );

  const emailData = useMemo(
    () => [
      {
        name: t('E-mail'),
        data: email,
        url: '/user/settings/edit-email',
        arrow,
      },
    ],
    [email]
  );

  const passwordData = useMemo(
    () => [
      {
        name: t('Wachtwoord'),
        data: '●●●●●●●●●●●●●',
        url: '/user/settings/edit-password',
        arrow,
      },
    ],
    []
  );

  const languageData = useMemo(
    () => [
      {
        name: t('Taal'),
        data: t(language),
        url: '/user/settings/edit-language',
        arrow,
      },
    ],
    [language]
  );

  return (
    <Card>
      <Stack space="m" width="100%">
        <Header
          title={t("Accountgegevens")}
          icon={<ProfileIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <div
          css={{
            'div[role=cell]': { overflowWrap: 'anywhere', hyphens: 'auto' },
          }}
        >
          <Table
            columns={columns}
            data={[...personData, ...emailData, ...passwordData, ...languageData]}
            handleRowClick={({ original }) => navigate(original.url)}
          />
        </div>
      </Stack>
    </Card>
  );
};

export default UserSection;
